import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import InvoiceDataModal from './InvoiceDataModal'
import InvoiceOptionsModal from './InvoiceOptionsModal'
import InvoiceSheetForPrint from './InvoiceSheetForPrint'
import jsPDF from 'jspdf'
import InvoiceBillingAddressModal from './InvoiceBillingAddressModal'
import InvoiceResendEmailInfoModal from './InvoiceResendEmailInfoModal'
import InvoiceResendEmailModal from './InvoiceResendEmailModal'
import CancelInvoiceOrderModal from '../../../modal/order/CancelInvoiceOrderModal'
import { setSelectedInvoice, setSelectedInvoiceOrder, setShowInvoiceCancelModal, setShowInvoiceOptionsModal } from '../../../../../redux/action/invoice'
import { selectSelectedInvoice, selectSelectedInvoiceOrder } from '../../../../../redux/selector/invoice'
import { cancelInvoiceOrderThunk } from '../../../../../redux/thunk/invoice'

const InvoiceTableModals = React.memo(({ onOpenOrder }) => {
	const dispatch = useDispatch()
	const showOptionsModal = useSelector(store => store.invoice.modal.showOptions)
	const showInvoiceDataModal = useSelector(store => store.invoice.modal.showInvoiceData)
	const showBillingAddressModal = useSelector(store => store.invoice.modal.showBillingAddress)
	const showInfoResendEmailModal = useSelector(store => store.invoice.modal.showInfoResendEmail)
	const showResendEmailModal = useSelector(store => store.invoice.modal.showResendEmail)
	const showCancelInvoiceModal = useSelector(store => store.invoice.modal.showCancelInvoice)
	const selectedInvoice = useSelector(selectSelectedInvoice)
	const invoiceOrder = useSelector(selectSelectedInvoiceOrder)

	const handlePrintInvoice = useCallback(() => {
		const invoiceForPrint = document.getElementById('invoice-sheet-for-print')
		const pdf = new jsPDF({
			orientation: 'p',
			unit: 'px',
			format: 'a4',
			hotfixes: ['px_scaling'],
		})
		pdf.html(invoiceForPrint, {
			callback: (pdf) => {
				pdf.autoPrint()
				pdf.output('dataurlnewwindow')
			},
			margin: [63, 0, 0, 0],
			x: 27,
			y: 0,
		})
	}, [])

	const closeCancelInvoiceModal = useCallback(() => {
		dispatch(setShowInvoiceCancelModal(false))
		dispatch(setShowInvoiceOptionsModal(true))
	}, [dispatch])

	const handleCancelInvoice = useCallback(async (reason, reasonCode) => {
		await dispatch(cancelInvoiceOrderThunk(selectedInvoice.id, invoiceOrder, reason, reasonCode))
		dispatch(setShowInvoiceCancelModal(false))
		dispatch(setSelectedInvoice(null))
		dispatch(setSelectedInvoiceOrder(null))
	}, [dispatch, selectedInvoice, invoiceOrder])

	return (
		<>
			{showOptionsModal && <InvoiceOptionsModal handlePrint={handlePrintInvoice} onOpenOrder={onOpenOrder} />}
			{showInvoiceDataModal && <InvoiceDataModal handlePrint={handlePrintInvoice} />}
			{showBillingAddressModal && <InvoiceBillingAddressModal />}
			{showInfoResendEmailModal && <InvoiceResendEmailInfoModal />}
			{showResendEmailModal && <InvoiceResendEmailModal />}
			<CancelInvoiceOrderModal isOpen={showCancelInvoiceModal}
												close={closeCancelInvoiceModal}
												onConfirm={handleCancelInvoice}
												order={invoiceOrder} />
			<InvoiceSheetForPrint />
		</>
	)
})

InvoiceTableModals.displayName = 'InvoiceTableModals'
export default InvoiceTableModals
